import { useEffect } from 'react';
import {
  disableAndroidAppRefresh,
  enableAndroidAppRefresh,
} from './utilFunctions';

// Disables the native Android WebView wrapper's pull-to-refresh for as long
// as `active` stays true (default: for the component's whole mounted
// lifetime), re-enabling on cleanup. Use for pages/popups whose scrolling
// the native scroll-position check can't see (e.g. an inner `overflow:
// auto` container), or that just want it suppressed while open/mounted.
export function useAndroidAppRefreshGate(active = true): void {
  useEffect(() => {
    if (!active) return;

    disableAndroidAppRefresh();

    return () => {
      enableAndroidAppRefresh();
    };
  }, [active]);
}
